// components
import GridPageAbstract from '../../GridPageAbstract';
import { ReceiveSquare2BulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class TransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'transactions';
        this.Server = this.props.context.getState().server.transactions;

        this.headerStartIcon = ReceiveSquare2BulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'id',
            'fromWallet.walletNumber',
            'toWallet.walletNumber'
        ];

        this.exportButton = true;

        this.hiddenColumns = config?.hiddenColumns?.transactions || [];

        this.Head = [
            {
                id: 'id',
                label: 'id',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'fromWalletsId',
                sortField: 'fromWallet.walletNumber',
                label: 'fromWallet',
                alignRight: false,
                cell: 'Associated',
                searchType: 'server', // server, client
                searchFields: ['walletNumber'], // for server search
                searchController: 'wallets', // for server search
                object: 'fromWallet',
                associatedSettings: {
                    primary: 'walletNumber',
                    secondary: 'currentBalance',
                    primaryType: 'text',
                    secondaryType: 'amount'
                },
                display: 'walletNumber',
                from: 'wallets',
                filterCell: 'Context',
                filterBy: 'wallets',
                displayFilter: 'wallets'
            },
            {
                id: 'fromCategory',
                sortField: 'fromWallet.kind',
                label: 'fromCategory',
                alignRight: false,
                cell: 'Label',
                disableEditor: true,
                object: 'fromWallet',
                display: 'kind',
                filterCell: 'Items',
                items: ['merchant', 'user'],
                needTranslate: true,
                filterField: 'fromWallet.kind'
            },
            {
                id: 'toWalletsId',
                sortField: 'toWallet.walletNumber',
                label: 'toWallet',
                alignRight: false,
                cell: 'Associated',
                associatedSettings: {
                    primary: 'walletNumber',
                    secondary: 'currentBalance',
                    primaryType: 'text',
                    secondaryType: 'amount'
                },
                object: 'toWallet',
                display: 'walletNumber',
                searchType: 'server', // server, client
                searchFields: ['walletNumber'], // for server search
                searchController: 'wallets', // for server search
                from: 'wallets',
                filterCell: 'Context',
                filterBy: 'wallets',
                displayFilter: 'wallets'
            },
            {
                id: 'toCategory',
                sortField: 'toWallet.kind',
                label: 'toCategory',
                alignRight: false,
                cell: 'Label',
                disableEditor: true,
                object: 'toWallet',
                display: 'kind',
                filterCell: 'Items',
                needTranslate: true,
                items: ['merchant', 'user'],
                filterField: 'toWallet.kind'
            },
            {
                id: 'exchangeRate',
                label: 'exchangeRate',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'coinOwnerFee',
                label: 'coinOwnerFee',
                alignRight: false,
                cell: 'Amount'
            },
            {
                id: 'systemFee',
                label: 'systemFee',
                alignRight: false,
                cell: 'Amount'
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: false,
                cell: 'Amount',
                filterCell: 'Range'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                readOnly: true,
                hideOnAdd: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));
    }
}
